import { forwardRef, useState, useRef, useCallback, useEffect } from 'react';
import { getSlideInStyles, getSlideInAsideStyles } from './SlideInStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { SlideInPosition } from './types/position.js';

const TRANSITION_DURATION = 300;
const SlideIn = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    isOpen,
    children,
    className: propClassName,
    position = SlideInPosition.RIGHT,
    elevationValue = 'above',
    size,
    fullWidthOnMobile = false,
    onClose,
    ...rest
  } = _ref;
  const [isRendered, setIsRendered] = useState(isOpen);
  const [isVisible, setIsVisible] = useState(false);
  const timeoutTransition = useRef();
  const openSlideIn = useCallback(() => {
    timeoutTransition.current && clearTimeout(timeoutTransition.current);
    setIsRendered(true);
    setIsVisible(true);
  }, []);
  const closeSlideIn = useCallback(() => {
    setIsVisible(false);
    timeoutTransition.current = setTimeout(() => {
      onClose === null || onClose === void 0 ? void 0 : onClose();
      setIsRendered(false);
    }, TRANSITION_DURATION);
  }, [onClose]);
  useEffect(() => {
    if (isOpen) {
      openSlideIn();
    } else if (isRendered) {
      closeSlideIn();
    }
  }, [isOpen, openSlideIn, closeSlideIn, isRendered]);
  useEffect(() => {
    return () => timeoutTransition.current && clearTimeout(timeoutTransition.current);
  }, []);
  return jsx("div", {
    css: getSlideInStyles(isVisible, fullWidthOnMobile, position, TRANSITION_DURATION, size),
    role: "dialog",
    "aria-hidden": !isOpen,
    className: propClassName,
    ref: ref,
    children: isRendered && jsx("aside", {
      className: propClassName,
      css: getSlideInAsideStyles(elevationValue),
      ...rest,
      children: children
    })
  });
});
SlideIn.displayName = 'SlideIn';

export { SlideIn };
//# sourceMappingURL=SlideIn.js.map
